module.exports = "<div class=\"content-custom\" data-ui-view='content'></div>";